import { useCallback, useState } from 'react';
import { vendorsApi } from 'src/app/services/Vendors/Vendors.service';
import { Layout, NotFound } from 'src/components/base';
import { LoadingOverlay } from 'src/components/base/LoadingOverlay/LoadingOverlay';
import { VendorLeadBillingInfo } from 'src/components/vendors/billing/VendorLeadBillingInfo';
import { VendorLeadBillingInfoDone } from 'src/components/vendors/billing/VendorLeadBillingInfoDone';

type VendorLeadBillingInfoPageProps = {
  vendorLocationId: string;
};

export function VendorLeadBillingInfoPage({ vendorLocationId }: Readonly<VendorLeadBillingInfoPageProps>) {
  const [isDone, setIsDone] = useState(false);

  const [{ data: vendorLeadBillingInfo, loading: isVendorLeadBillingInfoLoading, error: vendorLeadBillingInfoError }] =
    vendorsApi.useGetVendorLeadBillingInfoQuery(vendorLocationId);

  const handleSubmit = useCallback(() => {
    setIsDone(true);
  }, []);

  return (
    <Layout>
      {isDone ? (
        <VendorLeadBillingInfoDone />
      ) : (
        <LoadingOverlay
          className="flex-1 flex column nowrap justify-content-start align-items-stretch"
          isFirstLoading={isVendorLeadBillingInfoLoading}
          indicatorSize={64}
        >
          {vendorLeadBillingInfoError || !vendorLeadBillingInfo ? (
            <NotFound />
          ) : (
            <VendorLeadBillingInfo
              vendorLocationId={vendorLocationId}
              vendorLeadBillingInfo={vendorLeadBillingInfo}
              onSubmit={handleSubmit}
            />
          )}
        </LoadingOverlay>
      )}
    </Layout>
  );
}
